const DownloadURL = (url, name, extension = 'csv') => {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${name}.${extension}`;
  downloadLink.click();
};

export default DownloadURL;
